import { Injectable } from '@angular/core';
import { BroadcastService, ClientRulesService } from 'formbird-services';

@Injectable({
  providedIn: 'root'
})
// This is clone of util-sharing.service but have broadcast service
export class UtilSharingNgService {

   constructor(private clientRulesService: ClientRulesService
             , private broadcastService: BroadcastService) { }

   // Function that would trigger/call functions from one component to other components/ rules
   //  componentFieldName=>name of component that contains the function;functionName=> name of the function declared in componentFieldName
   // e.g component function call:scope.sclUtilSharing.fnCallFunction(scope.fieldName,'eventReloadDatatable');
   // e.g rules calling: UtilSharingLibrary.fnCallFunction('scDatatablesTest','eventReloadDatatable');
   fnCallFunction(componentFieldName: string, functionName: string, param1: any, param2: any): any {
      const value = {fieldName: componentFieldName, param1, param2, time: new Date()};
      this.broadcastService.broadcast(functionName, value);
      this.clientRulesService.setSharedValue(functionName, value);
      if (/get/.test(functionName.slice(0, 3))) {
      const objectData = this.clientRulesService.getSharedValue(functionName.replace(/^get/, 'set'));
      let objectDataReturn = [];
      if (objectData) {
         if (objectData.param1 && objectData.param2) {
            objectDataReturn.push(objectData.param1, objectData.param2);
         } else if (objectData.param1) {
            objectDataReturn = objectData.param1;
         } else {
            objectDataReturn = objectData;
         }
         return objectDataReturn;
         }
      }

   }

   // Function that would register a list of function to call in fnCallFunction
   // listOfFunctions=>['eventReloadDatatable','eventReloadTable','function1','...']
   // list of functions that will be available  in fnCallFunction to be called.
   // listOfFunctions = [{functionName, function}, ...];
   fnRegisterFunctions(listOfFunctions, fieldName, documentId) {
      for (let i = 0, n = listOfFunctions.length; i < n; i++) {
         this.fnCreateWatchForFunctionCall(listOfFunctions[i].name, listOfFunctions[i].fn, fieldName, documentId);
      }
   }

   fnCreateWatchForFunctionCall(functionName, fn, fieldName, documentId) {
      this.broadcastService.on(functionName).subscribe((objValue: any) => {
         // console.log('%c broadcast on, functionName = ' + functionName, 'color:blue');
         if (objValue) {
            // logger.info(functionName," is watch",objValue,objValue.fieldName,scope.fieldName);
            if (fieldName === objValue.fieldName) {

               // logger.info(objValue.fieldName,scope.fieldName,variableFunction,fn);
               if (objValue.param1 && objValue.param2) {
                  // variableFunction = "scope."+functionName+"('"+objValue.param1+"','"+objValue.param2+"')";
                  fn(objValue.param1, objValue.param2);
               } else if (objValue.param1) {
                  // variableFunction = "scope."+functionName+"('"+objValue.param1+"')";
                  fn(objValue.param1);
               } else {
                  fn();
               }



               // eval("(" + variableFunction + ")");
            }
         }
      });
   }

   fnPassedDataObject(fieldName, objectName, objectDataValue) {
      this.clientRulesService.setSharedValue(objectName, {fieldName, objectDataValue, time: new Date().getTime()});
   }
   fnGetDataObject(fieldName, objectName) {
      const objectData = this.clientRulesService.getSharedValue(objectName);
      return  objectData.fieldName === fieldName ? objectData : null ;
   }
}
